export {getFocusableTreeWalker, createFocusManager, isElementInChildOfActiveScope} from '../../../src/focus/FocusScope';
